import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { BaseService } from './base'

/**
 * Voice inspection mode (the mobile app reads questions aloud and takes
 * spoken answers). The web only manages the company settings and reviews
 * the stored question translations. Admin-only on the server (403 otherwise).
 */
class VoiceServiceClass {
    getLanguages() {
        return BaseService.get(APIPath.voiceLanguages)
    }

    getCompanySetting() {
        return BaseService.get(APIPath.voiceCompanySetting)
    }

    saveCompanySetting({ voiceEnabled, noteLanguage, keepAudio, defaultHearLanguage }) {
        return BaseService.post(APIPath.voiceCompanySetting, {
            VoiceEnabled: !!voiceEnabled,
            NoteLanguage: noteLanguage || null,
            KeepAudio: !!keepAudio,
            DefaultHearLanguage: defaultHearLanguage || null,
        })
    }

    listTranslations({ lang, reviewed, search, page = 1, size = 25 } = {}) {
        const query = { page, size }
        if (lang) query.lang = lang
        if (reviewed === true || reviewed === false) query.reviewed = reviewed
        if (search) query.search = search
        return BaseService.get(
            `${APIPath.voiceTranslations}?${CommonUtility.objectToParams(query)}`,
        )
    }

    /** Voice accuracy report (counts the phones send after each voice session); days 1..365. */
    getAccuracyReport(days = 30) {
        return BaseService.get(
            `${APIPath.voiceAccuracyReport}?${CommonUtility.objectToParams({ days })}`,
        )
    }

    updateTranslation(translationId, translatedText) {
        return BaseService.post(APIPath.voiceTranslation(translationId), {
            TranslatedText: translatedText,
        })
    }
}

export const VoiceService = new VoiceServiceClass()
